import Page from '@/components/pages/search/SearchPageController';
import getStaticProps from '@/components/pages/search/SearchPageStaticProps';

export default Page;
export { getStaticProps };
